import React, { ReactNode } from "react";
import ArticleFeature from "../../assets/article_feature.jpg";
import { Link } from "gatsby";
import { Article } from "../../types/articles";

type PostCardProps = {
  direction: "row" | "column";
  children?: ReactNode;
  data: Article;
};


const PostCard = ({ direction, data }: PostCardProps) => {
  return (
    <div className={`flex ${direction === 'row' ? 'flex-col md:flex-row' : ''} ${direction === 'column' ? 'flex-col' : ''} justify-center items-center gap-[50px]`}>
      <div className="flex-1 overflow-hidden rounded-md">
        <img src={data.image.publicURL || ArticleFeature} alt="" className="w-full aspect-video" />
      </div>
      <div className="flex-1 flex flex-col gap-[20px] justify-center">
        <span className="bg-[#26025D] text-white px-[.5rem] py-[.2rem] rounded-md w-fit">
          {data.category || "Lifestyle"}
        </span>
        <h2 className="text-[1.5rem] font-[700]">
          {data.title || "Cómo la microbiota afecta a nuestro cerebro"}
        </h2>
        <p>
          {data.short_text}
        </p>
        <Link to="/" className="hover:text-[red] font-[500] mt-auto">
          Read more <span className="ml-[5px]">&gt;</span>
        </Link>
      </div>
    </div>
  );
};

export default PostCard;
